import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useBoolean } from 'src/hooks/use-boolean';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import Label from 'src/components/label';
import { useNavigate } from 'react-router';
import ShareModal from './share-generate-payroll';
import { useProfileContext } from 'src/components/profile/context';
import { formatCurrency } from '../../risk-register/feching';
import { CircularProgress, List, ListItem } from '@mui/material';
import { useState } from 'react';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { LoadingButton } from '@mui/lab';
// ----------------------------------------------------------------------
export default function UserTableRows({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  serialNumber,
  reload,
  users
}) {
  console.log("🚀 ~ row:::::::::::::::::", row)
  const confirm = useBoolean();
  const add = useBoolean();
  const [ loading, setLoading ] = useState(false);
  const [ statusAnchorEl, setStatusAnchorEl ] = useState(null);
  const isStatusPopoverOpen = Boolean(statusAnchorEl);
  const { userProfile } = useProfileContext();
  console.log("🚀 ~ userProfile:", userProfile)

  const statusOptions = [
    { id: 1, name: "PENDING ", color: "error" },
    { id: 2, name: "APPROVED ", color: "success" },
    { id: 3, name: "PAYMENT_SENT ", color: "info" },
    { id: 4, name: "REJECTED", color: "warning" },
  ];

  const handleStatusClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };

  const handleStatusPopoverClose = () => {
    setStatusAnchorEl(null);
  };


  const handleStatusChange = async (selectedStatus) => {
    setLoading(true);
    try {
      await getRequest(`${endpoints.accounting.payroll.generate_payroll.status_change}/${row.id}/update-status/${selectedStatus.id}`);
      reload();
    } catch (error) {
      console.error('Error toggling status:', error);
    } finally {
      setLoading(false);
      handleStatusPopoverClose();
    }
  };

  const popover = usePopover();
  const navigate = useNavigate();
  const { payroll_number, week_ending_date, total_gross_amount, total_weekly_paid_wages, payment_method, status } = row
  return (
    <>
      <TableRow hover selected={ selected }>
        <TableCell padding="checkbox">
          <Checkbox checked={ selected } onClick={ onSelectRow } />
        </TableCell>
        <TableCell>{ serialNumber }</TableCell>
        <TableCell>{ payroll_number }</TableCell>
        <TableCell>{ userProfile?.first_name } { userProfile?.last_name }</TableCell>
        <TableCell>{ week_ending_date }</TableCell>
        <TableCell>{ userProfile?.address }{ userProfile?.city }{ userProfile?.zip }</TableCell>
        <TableCell>{ formatCurrency(total_gross_amount) }</TableCell>
        <TableCell>{ formatCurrency(total_weekly_paid_wages) }</TableCell>
        <TableCell>
          <Label
            variant="soft"
            color={
              (payment_method === 'paid' && 'success') ||
              (payment_method === 'unpaid' && 'warning') ||
              (payment_method === 'overdue' && 'error') ||
              'default'
            }
          >
            { payment_method }
          </Label>
        </TableCell>
        <TableCell sx={ { justifyContent: "center", cursor: "pointer" } } onClick={ handleStatusClick }>
          { loading ? <CircularProgress size={ 24 } color="success" /> :
            <Label
              variant="soft"
              color={ statusOptions?.find(s => s.id === status?.value)?.color || 'default' }
              style={ { cursor: "pointer" } }
            >
              { status?.name }
            </Label>
          }
        </TableCell>
        <TableCell align="right" sx={ { px: 1, whiteSpace: 'nowrap' } }>
          <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ popover.onOpen }>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
          <LoadingButton
            mx={ 2 }
            onClick={ () => {
              if (status?.name?.toLowerCase() === 'approved') {
                navigate(`/accounts-management/payroll/genrate-payroll/issue/${row.id}`);
              }
            } }
            className="dark-button"
            variant="contained"
            size="small"
            startIcon={ <Iconify icon="material-symbols:payments" /> }
            disabled={ status?.name?.toLowerCase() !== 'approved' }
            sx={ {
              opacity: status?.name?.toLowerCase() !== 'approved' ? 0.6 : 1,
              pointerEvents: status?.name?.toLowerCase() !== 'approved' ? 'none' : 'auto',
              cursor: status?.name?.toLowerCase() !== 'approved' ? 'not-allowed' : 'pointer',
            } }
          >
            Issue payment
          </LoadingButton>

        </TableCell>
      </TableRow>

      <CustomPopover
        open={ isStatusPopoverOpen }
        anchorEl={ statusAnchorEl }
        onClose={ handleStatusPopoverClose }
        anchorOrigin={ {
          vertical: 'bottom',
          horizontal: 'left',
        } }
        transformOrigin={ {
          vertical: 'top',
          horizontal: 'right',
        } }
      >
        <List sx={ { width: 150 } }>
          { statusOptions.map((statusOption) => (
            <ListItem
              key={ statusOption.id }
              sx={ { cursor: 'pointer', px: 2, py: 1, display: 'flex', alignItems: 'center' } }
              onClick={ () => handleStatusChange(statusOption) }
            >
              <Label variant="soft" color={ statusOption.color } sx={ { flexGrow: 1, cursor: 'pointer' } } >
                { statusOption.name }
              </Label>
            </ListItem>
          )) }
        </List>
      </CustomPopover>


      <CustomPopover
        open={ popover.open }
        onClose={ popover.onClose }
        arrow="right-top"
        sx={ { width: 140 } }
      >
        <MenuItem
          onClick={ () => navigate(`/accounts-management/payroll/genrate-payroll/view/${row.id}`, {
          }) }
        >
          <Iconify icon="solar:eye-bold" />
          View
        </MenuItem>
        <MenuItem
          onClick={ () => {
            confirm.onTrue();
            popover.onClose();
          } }
          sx={ { color: 'error.main' } }
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
        <MenuItem
          onClick={ () => {
            add.onTrue();
          } }
        >
          <Iconify icon="material-symbols:share-reviews" />
          Share
        </MenuItem>
      </CustomPopover>


      <ShareModal
        open={ add.value }
        onClose={ add.onFalse }
        reload={ reload }
        users={ users }
        currentItem={ row }
      />
      <ConfirmDialog
        open={ confirm.value }
        onClose={ confirm.onFalse }
        title="Delete"
        content="Are you sure you want to delete?"
        action={
          <Button
            className="dark-button"
            variant="contained"
            color="error"
            onClick={ () => {
              confirm.onFalse();
              onDeleteRow(row.id);
              console.log('>>>>>>>', row.id);
            } }
          >
            Delete
          </Button>
        }
      />
    </>
  );
}
UserTableRows.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};